module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("选择关联用户")]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "您的微信账号关联了多个Octomaste用户，请在以下列表中选择要查看的用户"
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('cell', {
      key: user.id,
      attrs: {
        "title": _vm.displayName(user),
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.loginUser(user.id)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef79996a"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmLogin.vue
// module id = 576
// module chunks = 1